import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NavigationTrackerService } from '../utils/navigation-tracker.service';
import * as Highcharts from 'highcharts';
import HC_exporting from 'highcharts/modules/exporting';
import HC_3d from 'highcharts/highcharts-3d';
import { GeneralService } from '../api/config/general.service';
import * as moment from 'moment';
import { GlobalService } from '../api/global.service';
import { constants } from '../constants';
HC_exporting(Highcharts);
HC_3d(Highcharts);

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {
  branchofficeSlug = '';
  updateFlag = false;

  Highcharts: typeof Highcharts = Highcharts;
  chartOptions: Highcharts.Options = {};
  graphSummaryTypeVoucherOptions: Highcharts.Options = {};

  // tourChartOptions: Highcharts.Options;

  // default category_company
  category_selected: any = null;
  category_general_services: any = constants.COMPANY.CATEGORY.GENERAL_SERVICES;

  // variables | SERVICIOS GENERALES
  count_product: any = 0;
  count_provider: any = 0;
  total_sale_month: any = 0;
  graph_sale_month: any = 0;
  graph_summary_typevoucher_month: any = 0;

  // variables
  date_result: any = moment();
  count_booking: any = 0;
  count_tour: any = 0;
  count_client: any = 0;
  count_hotel: any = 0;
  total_income_day: any = 0;
  arrivals: any = [];
  historico_bookings: any = [];

  obj_months = [
    { number_month: 1, name: 'Ene', value: 0 },
    { number_month: 2, name: 'Feb', value: 0 },
    { number_month: 3, name: 'Mar', value: 0 },
    { number_month: 4, name: 'Abr', value: 0 },
    { number_month: 5, name: 'May', value: 0 },
    { number_month: 6, name: 'Jun', value: 0 },
    { number_month: 7, name: 'Jul', value: 0 },
    { number_month: 8, name: 'Ago', value: 0 },
    { number_month: 9, name: 'Set', value: 0 },
    { number_month: 10, name: 'Oct', value: 0 },
    { number_month: 11, name: 'Nov', value: 0 },
    { number_month: 12, name: 'Dec', value: 0 }
  ];

  constructor(
    private routeActivated: ActivatedRoute,
    private globalService: GlobalService,
    private generalService: GeneralService,
    private navigationTrackerService: NavigationTrackerService
  ) {
    this.branchofficeSlug = this.globalService.slugBranchoffice;
    this.category_selected = this.globalService.getCompany().category_id;
    // this.tourChartOptions = {
    //   chart: {
    //     renderTo: 'container',
    //     type: 'column',
    //     options3d: {
    //       enabled: true,
    //       alpha: 15,
    //       beta: 15,
    //       depth: 50,
    //       viewDistance: 25
    //     }
    //   },
    //   xAxis: {
    //     categories: [
    //       'Toyota', 'BMW', 'Volvo', 'Audi', 'Peugeot', 'Mercedes-Benz',
    //       'Volkswagen', 'Polestar', 'Kia', 'Nissan'
    //     ]
    //   },
    //   yAxis: {
    //     // title: {
    //     //   enabled: false
    //     // }
    //   },
    //   tooltip: {
    //     headerFormat: '<b>{point.key}</b><br>',
    //     pointFormat: 'Cars sold: {point.y}'
    //   },
    //   title: {
    //     text: 'Sold passenger cars in Norway by brand, January 2021',
    //     align: 'left'
    //   },
    //   subtitle: {
    //     text: 'Source: <a href="https://ofv.no/registreringsstatistikk" target="_blank">OFV</a>',
    //     align: 'left'
    //   },
    //   legend: {
    //     enabled: false
    //   },
    //   plotOptions: {
    //     column: {
    //       depth: 25
    //     }
    //   },
    //   series: [{
    //     type: "bar",
    //     data: [1318, 1073, 1060, 813, 775, 745, 537, 444, 416, 395],
    //     colorByPoint: true
    //   }]
    // };
  }

  ngOnInit() {
    this.navigationTrackerService.initializeMenu(this.routeActivated);
    if (this.category_selected == this.category_general_services.id) {
      this.initializeChartSalesByMonth();
      this.initializeGraphSummaryTypeVoucher({ name: 'Comprobante', y: 0 }, 0);
      this.dashboardGeneralServices();
    } else {
      this.initializeChart();
      this.dashboardDefault();
    }
  }

  // acciones | SERVICIOS GENERALES

  dashboardGeneralServices() {
    this.generalService.dashboardGeneralService().subscribe({
      next: (data: any) => {
        this.date_result = data.date_result;
        this.count_product = data.count_product;
        this.count_client = data.count_client;
        this.count_provider = data.count_provider;
        this.total_sale_month = data.total_sale_month;
        this.graph_sale_month = data.graph_sale_month;
        this.graph_summary_typevoucher_month =
          data.graph_summary_typevoucher_month;

        let series: any = [];
        let total_ventas: any = 0;
        let total_comprobantes: any = 0;
        for (let i in this.graph_summary_typevoucher_month) {
          let obj_: any = {
            name: this.graph_summary_typevoucher_month[i].description,
            y: Number(this.graph_summary_typevoucher_month[i].total_ventas),
            quantity: Number(this.graph_summary_typevoucher_month[i].cantidad_ventas),
          };
          series.push(obj_);
          total_ventas = total_ventas + Number(this.graph_summary_typevoucher_month[i].total_ventas);
          total_comprobantes = total_comprobantes + Number(this.graph_summary_typevoucher_month[i].cantidad_ventas);
        }

        setTimeout(() => {
          this.updateChartDataSalesByMonth(this.graph_sale_month);
          this.initializeGraphSummaryTypeVoucher(series, total_ventas, total_comprobantes);
        }, 150);
      }
    });
  }

  initializeChartSalesByMonth() {
    this.chartOptions = {
      chart: {
        type: 'line'
      },
      title: {
        text: 'Histórico de ventas por mes'
      },
      subtitle: {
        text: 'Año: ' + moment(this.date_result).format('YYYY')
      },
      xAxis: {
        categories: [
          'Ene',
          'Feb',
          'Mar',
          'Abr',
          'May',
          'Jun',
          'Jul',
          'Ago',
          'Set',
          'Oct',
          'Nov',
          'Dic'
        ]
      },
      yAxis: {
        title: {
          text: 'Total S/'
        }
      },
      series: [
        {
          name: 'Meses',
          type: 'line',
          data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
        }
      ]
    };
  }

  updateChartDataSalesByMonth(datos: any) {
    let series_parse: any = [];
    for (let i in this.obj_months) {
      for (let j in datos) {
        if (this.obj_months[i].number_month == datos[j].number_month) {
          this.obj_months[i].value = parseFloat(datos[j].total_month);
        }
      }
      series_parse.push(this.obj_months[i].value);
    }

    this.chartOptions = {
      series: [
        {
          name: 'Total Ventas S/',
          type: 'line',
          data: series_parse
        }
      ]
    };
    this.updateFlag = true;
  }

  initializeGraphSummaryTypeVoucher(series: any, total_ventas: any, total_comprobantes:any  = 0) {
    this.graphSummaryTypeVoucherOptions = {
      chart: {
        renderTo: 'container',
        type: 'pie',

        marginTop: 100 // Ajusta el valor según el espacio que desees entre el gráfico y el subtítulo
      },
      tooltip: {
        pointFormat: '{series.name}: S/ <b>{point.y:0f}</b>  </br>N° comprobantes:<b>{point.quantity:0f}</b> '
      },
      title: {
        text: 'RESUMEN FACTURADO S/ DEL MES',
        style: {
          fontSize: '15px'
        }
      },
      subtitle: {
        text: 'Total S/ ' + total_ventas + ' facturado' + ' | N° comprobantes:'+total_comprobantes
      },
      legend: {
        enabled: false
      },
      plotOptions: {
        series: {
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: [
            {
              enabled: true,
              format: '{point.name}',
              style: {
                fontSize: '0.8em'
              },
              x: 0, // Mueve el label a la derecha
              y: -20 // Mueve el label hacia arriba
            },
            {
              enabled: true,
              format: 'S/ {point.y}',
              style: {
                fontSize: '0.8em',
                fontWeight: '500'
              }
            }
          ],
          showInLegend: true
        }
      },
      series: [
        {
          type: 'pie',
          name: 'N°:',
          data: series
        }
      ]
    };
  }

  // ==== FIN SERVICIOS GENERALES

  // acciones | DASHBOARD DEFAULT
  dashboardDefault() {
    this.generalService.dashboard().subscribe({
      next: (data: any) => {
        this.date_result = data.date_result;
        this.count_booking = data.count_booking;
        this.count_client = data.count_client;
        this.count_hotel = data.count_hotel;
        this.count_tour = data.count_tour;
        this.arrivals = data.arrivals;
        this.historico_bookings = data.history_bookings;
        let series: any = [];
        for (let i in this.obj_months) {
          for (let j in this.historico_bookings) {
            if (
              this.obj_months[i].number_month ==
              this.historico_bookings[j].number_month
            ) {
              this.obj_months[i].value = parseFloat(
                this.historico_bookings[j].quantity_month
              );
            }
          }
          series.push(this.obj_months[i].value);
        }
        setTimeout(() => {
          this.updateChartData(series);
        }, 150);
      }
    });
  }

  initializeChart() {
    this.chartOptions = {
      chart: {
        type: 'line'
      },
      title: {
        text: 'Histórico de Reservas por mes'
      },
      subtitle: {
        text: 'Año: ' + moment(this.date_result).format('YYYY')
      },
      xAxis: {
        categories: [
          'Ene',
          'Feb',
          'Mar',
          'Abr',
          'May',
          'Jun',
          'Jul',
          'Ago',
          'Set',
          'Oct',
          'Nov',
          'Dic'
        ]
      },
      yAxis: {
        title: {
          text: 'Cantidad'
        }
      },
      series: [
        {
          name: 'Meses',
          type: 'line',
          data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
        }
      ]
    };
  }

  updateChartData(series: any) {
    this.chartOptions = {
      series: [
        {
          name: 'N° reservas',
          type: 'line',
          data: series
        }
      ]
    };
    this.updateFlag = true;
  }
}
